var BlockView = require('views/block/base-block-view');
import IconLoadService from 'services/icon-load-service';

var LabelView = BlockView.extend({
  initialize: function () {
    this.icon = this.model.get('icon');
    this.customClasses = [];
    if (this.icon && this.icon.class) {
      // rename model attr class to another variable name like className
      this.model.set('iconType', this.icon.class);
      this.model.set('iconPrefix', this.icon.prefix_label || 'fal');
    } else if(typeof this.icon === 'string') {
      // this flag is temporal, will be removed.
      this.model.set('newIcon', true)
      this.model.set('icon', this.icon);
    }
    BlockView.prototype.initialize.apply(this, arguments);
  },
  load: function () {
    this.cid = this.model.get('cid');
    const icon = this.model.get('icon');
    
    if (this.model.get('iconPrefix') && this.model.get('iconType')) {
      IconLoadService.applyIcon(this.model.get('iconType'), this.cid, this.customClasses, this.model.get('iconPrefix'));
    } else if(typeof icon === 'string')  {
      IconLoadService.applyIcon(this.icon, this.cid, this.customClasses);
    } else if (typeof icon === 'object' && icon.hasOwnProperty('class')) {
      IconLoadService.applyIcon(this.icon.class, this.cid, this.customClasses);
    }
  },
  play: function () {
    this.readyToGo();
  }
});

module.exports = LabelView;
